// Proje katılımcı (müşteri) API wrapper'ları — Müşteri Katılımcı Rolü (Task 7).
// Backend route'ları: apps/backend/src/routes/projects.ts "Task 5 — Müşteri Katılımcı
// Rolü" bölümü. Şema/tipler packages/shared/src/schemas/project-participants.ts
// (Task 1/5) ile birebir — burada sadece method/path sarmalanır.

import type {
  InviteParticipantRequest,
  InviteParticipantResponse,
  ParticipantListResponse,
  ParticipantStatus,
  ResendInviteResponse,
} from "@mahir/shared";
import { api } from "./client";

// GET /projects/:id/participants — liste (izin: projects.invite_client)
export async function listParticipants(projectId: string): Promise<ParticipantListResponse> {
  return api<ParticipantListResponse>(`/projects/${projectId}/participants`);
}

// POST /projects/:id/participants — davet (izin: projects.invite_client)
export async function inviteParticipant(
  projectId: string,
  body: InviteParticipantRequest,
): Promise<InviteParticipantResponse> {
  return api<InviteParticipantResponse>(`/projects/${projectId}/participants`, {
    method: "POST",
    body,
  });
}

// PATCH /projects/:id/participants/:pid — yeniden aç (active) / iptal (revoked)
export async function setParticipantStatus(
  projectId: string,
  participantId: string,
  status: Extract<ParticipantStatus, "active" | "revoked">,
): Promise<{ ok: true }> {
  return api<{ ok: true }>(`/projects/${projectId}/participants/${participantId}`, {
    method: "PATCH",
    body: { status },
  });
}

// POST /projects/:id/participants/:pid/resend — aktivasyon mailini yeniden gönder
export async function resendParticipantInvite(
  projectId: string,
  participantId: string,
): Promise<ResendInviteResponse> {
  return api<ResendInviteResponse>(`/projects/${projectId}/participants/${participantId}/resend`, {
    method: "POST",
    body: {},
  });
}

// POST /projects/:id/participants/submit — client self-submit (Task 8, whitelist'te
// var). missingCount FE'den gönderilmez, route kendi hesaplar (getMissingFields).
export async function submitParticipation(projectId: string): Promise<{ ok: true }> {
  return api<{ ok: true }>(`/projects/${projectId}/participants/submit`, {
    method: "POST",
    body: {},
  });
}
